import React from 'react'
import {Icon} from '@chakra-ui/react'

const FiltersIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_315_1609)">
                <rect
                    x="3.33496"
                    y="10.2083"
                    width="33.3333"
                    height="2.91667"
                    fill="currentColor"
                />
                <rect
                    x="27.084"
                    y="18.3333"
                    width="13.3333"
                    height="2.91667"
                    transform="rotate(-90 27.084 18.3333)"
                    fill="currentColor"
                />
                <rect x="3.33496" y="26.875" width="33.3333" height="2.91667" fill="currentColor" />
                <rect
                    x="10.002"
                    y="35"
                    width="13.3333"
                    height="2.91667"
                    transform="rotate(-90 10.002 35)"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_315_1609">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000244141)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default FiltersIcon
